<template>
  <div v-if="hasPermission('has_inline_help')">
    <div class="pl-2">
      [ <a class="caption" @click="showDialog">example</a> ]
    </div>

    <v-dialog
      v-model="enabled"
      @keydown.esc.prevent="closeDialog"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      @input="v => v || closeDialog"
      lazy
      max-width="940px"
      scrollable
    >
      <v-card>
        <v-toolbar dense flat>
          <v-toolbar-title>Invoice Example</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon flat color="primary" @click.native="closeDialog">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-divider class="primary"></v-divider>

        <v-card-text>
          <v-card elevation="4">
            <v-card-text>
              <table class="email--table">
                <tr>
                  <th>From:</th>
                  <td>merchant@example.com</td>
                </tr>
                <tr>
                  <th>To:</th>
                  <td>customer@example.com</td>
                </tr>
                <tr>
                  <th>Subject:</th>
                  <td>January Invoice</td>
                </tr>
                <tr>
                  <td colspan="2">
                    Dear Mrs. Smith,
                    <br />
                    Thank you for your business.
                    <br />
                    Please pay the $50 with Payment Link below.
                    <br />
                    <template v-if="environment === 'development'">
                      <a href="https://payments-dev.paynetworx.com?token=24Yysar1iAeGK8S4fn9L7exozKC?amount=5000" target="_blank">Pay Here Now</a>
                    </template>
                    <template v-else>
                      Pay Here Now
                    </template>
                  </td>
                </tr>
              </table>
            </v-card-text>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Bus from '@/bus'

import AuthMixin from '@/mixins/auth'

export default {
  mixins: [AuthMixin],

  data: function () {
    return {
      enabled: false,
      environment: process.env.NODE_ENV,
      imageUrl: process.env.VUE_APP_IMAGE_URL
    }
  },

  beforeDestroy () {
    Bus.$off('closeDialog')
  },

  mounted () {
    Bus.$on('closeDialog', this.closeDialog)
  },

  methods: {
    async showDialog () {
      try {
        this.enabled = true
      } catch (err) {
        Bus.$emit('openDialog', {
          status: 'error',
          message: err
        })
      }
    },

    closeDialog () {
      Bus.$emit('optionsClose')
      this.enabled = false
    }
  }
}
</script>

<style lang="less">
  .email--table {
    width: 100%;
  }
  .email--table th {
    background-color: lightgray;
    border: 1px solid black;
    padding-right: 1em;
    text-align: right;
  }
  .email--table td {
    border: 1px solid black;
    padding: 1em;
  }
</style>



// WEBPACK FOOTER //
// src/components/help/ExampleInvoiceDialog.vue